// extracted by mini-css-extract-plugin
module.exports = {"wb-logo":"wb-logo__22tvX","wb-logo__image":"wb-logo__image__3YF5x"};